// API Configuration - Automatically detects environment
const getApiBaseUrl = () => {
  // Check if we're in production (hosted on your domain)
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    // Production mode - Backend URL (Railway)
    return 'https://api.teachlypro.com/api';
  }
  
  // Development mode - use localhost
  return 'http://localhost:5001/api';
};

export const API_BASE_URL = getApiBaseUrl();

// Log API URL for debugging
console.log('🔗 API Base URL:', API_BASE_URL);
console.log('🌐 Current hostname:', window.location.hostname);


